<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M7.99816 0.640626C6.66694 0.641041 5.36075 1.00253 4.21871 1.68659C3.07669 2.37066 2.14159 3.35168 1.51302 4.52517C0.884448 5.69865 0.585945 7.02066 0.649303 8.35038C0.712659 9.6801 1.13551 10.9677 1.8728 12.0761L0.638672 15.3597L4.77131 14.6123C5.76644 15.0986 6.85848 15.3541 7.96606 15.3595C9.07364 15.365 10.1682 15.1205 11.1681 14.644C12.1679 14.1677 13.0475 13.4717 13.7409 12.608C14.4343 11.7445 14.9241 10.7354 15.1732 9.65624C15.4225 8.57706 15.425 7.45554 15.1804 6.37529C14.9358 5.29503 14.4507 4.2839 13.761 3.41727C13.0713 2.55063 12.1948 1.85086 11.197 1.37009C10.1992 0.889322 9.10575 0.639973 7.99816 0.640626Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M4.22852 9.14307C4.79994 11.2002 7.08566 12.4574 9.1428 11.8859C10.3999 11.4288 11.4285 10.4002 11.7714 9.14307"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.42829 6.28578C5.2705 6.28578 5.14258 6.15786 5.14258 6.00007C5.14258 5.84228 5.2705 5.71436 5.42829 5.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M5.42773 6.28578C5.58553 6.28578 5.71345 6.15786 5.71345 6.00007C5.71345 5.84228 5.58553 5.71436 5.42773 5.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.5709 6.28578C10.4131 6.28578 10.2852 6.15786 10.2852 6.00007C10.2852 5.84228 10.4131 5.71436 10.5709 5.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M10.5703 6.28578C10.7281 6.28578 10.856 6.15786 10.856 6.00007C10.856 5.84228 10.7281 5.71436 10.5703 5.71436"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
